import axios from 'axios';
import { getSessionToken } from '@tiendanube/nexo';
import nexo from '../nexoClient';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
});

api.interceptors.request.use(async (config) => {
  try {
    const token = await getSessionToken(nexo);
    config.headers.Authorization = `Bearer ${token}`;
  } catch (error) {
    console.warn('Failed to get session token:', error);
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Session expired or invalid');
    }
    return Promise.reject(error);
  }
);

export interface N8nConfig {
  host: string;
  username?: string;
  password?: string;
}

export interface ConnectionTestResult {
  success: boolean;
  latency?: number;
  error?: string;
}

export interface StoreCredentials {
  storeId: string;
  accessToken: string;
  storeName?: string;
  storeUrl?: string;
}

export interface Webhook {
  id: number;
  event: string;
  url: string;
  created_at: string;
  updated_at: string;
}

export interface CreateWebhookData {
  event: string;
  url: string;
}

export interface UpdateWebhookData {
  event?: string;
  url?: string;
}

export const n8nConfigApi = {
  get: () => api.get<N8nConfig | null>('/n8n-config'),
  save: (config: N8nConfig) => api.post('/n8n-config', config),
  test: () => api.get<ConnectionTestResult>('/n8n-config/test'),
};

export const storeApi = {
  getCredentials: () => api.get<StoreCredentials>('/store/credentials'),
};

export const webhooksApi = {
  list: () => api.get<Webhook[]>('/webhooks'),
  get: (id: number) => api.get<Webhook>(`/webhooks/${id}`),
  create: (data: CreateWebhookData) => api.post<Webhook>('/webhooks', data),
  update: (id: number, data: UpdateWebhookData) => api.put<Webhook>(`/webhooks/${id}`, data),
  delete: (id: number) => api.delete(`/webhooks/${id}`),
};

export default api;
